/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Hardware_1Inputs */

const en_svr_guidance_hardware_1 = /** @type {(inputs: Svr_Guidance_Hardware_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If hardware was replaced: part code and serial numbers (old and new)`)
};

const ja_svr_guidance_hardware_1 = /** @type {(inputs: Svr_Guidance_Hardware_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハードウェアを交換した場合：部品コードとシリアル番号（旧と新）`)
};

const fr_svr_guidance_hardware_1 = /** @type {(inputs: Svr_Guidance_Hardware_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si du matériel a été remplacé : code pièce et numéros de série (ancien et nouveau)`)
};

const de_svr_guidance_hardware_1 = /** @type {(inputs: Svr_Guidance_Hardware_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Hardwaretausch: Teilenummer und Seriennummern (alt und neu)`)
};

/**
* | output |
* | --- |
* | "If hardware was replaced: part code and serial numbers (old and new)" |
*
* @param {Svr_Guidance_Hardware_1Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_hardware_1 = /** @type {((inputs?: Svr_Guidance_Hardware_1Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Hardware_1Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_hardware_1(inputs)
	if (locale === "ja") return ja_svr_guidance_hardware_1(inputs)
	if (locale === "fr") return fr_svr_guidance_hardware_1(inputs)
	return de_svr_guidance_hardware_1(inputs)
});